import React from 'react';
import styles from '../../styles/CareerStyles/CareerInfo.module.css';

const CareerInfo = () => {
  return (
    <div className={styles.container}>
      
      <div className={styles.textSection}>
        <div className={styles.intro}>
          <h3 className={styles.title}>
            About Our Team 
          </h3>
          <p className={styles.description}>
            We are a team of dedicated professionals with huge experience in project and programme development, delivering idea into action and results.  who are passionate about making a difference in the world.
            Our team is made up of experts in various fields, including environment and climate, engineering and social sciences.
            
          </p>
        </div>

        <div className={styles.stats}>
          <div className={styles.statBlock}>
            <h3 className={styles.statNumber}></h3>
            <p className={styles.statLabel}></p>
          </div>
          <div className={styles.statBlock}>
            <h3 className={styles.statNumber}></h3>
            <p className={styles.statLabel}></p>
          </div>
        </div>
      </div>

      <div className={styles.imageSection}>
        <img
          className={styles.image}
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
          alt="Career"
        />
      </div>

    </div>
  );
};

export default CareerInfo;
